import * as React from "react";
import Form, { FormComponentProps } from "antd/lib/form";
import { TTranslate } from "../../../service/locale/TranslationService";
import { IFormType } from "../../../model/formconfiguration/FormType";
import { FormTypeFormConstants } from "../../../common/Constants";
import { Input } from "antd";

export interface State {}

export interface CopyFormTypeFormProps extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler?: any;
  rowData: IFormType;
  copyFormType: any;
}

class CopyFormTypeForm extends React.Component<CopyFormTypeFormProps, State> {
  componentDidMount() {
    const { registerFormSubmitEventHandler } = this.props;
    registerFormSubmitEventHandler((e) => {
      e.preventDefault();
      let copyFormTypeData;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          copyFormTypeData = values;
        }
      });
      return copyFormTypeData;
    });
  }

  render() {
    const { translate, rowData } = this.props;
    const { getFieldDecorator } = this.props.form;
    return (
      <Form>
        <Form.Item label={translate("formType_form.existing_form_code")}>
          {getFieldDecorator(FormTypeFormConstants.Fields.OLD_CODE, {
            initialValue: rowData && rowData.code,
            rules: [
              {
                required: rowData ? false : true,
                message: translate("formType_form.required_messages", {
                  field: translate("formType_form.code")
                })
              }
            ]
          })(
            <Input
              disabled={true}
              readOnly={rowData ? true : false}
              maxLength={FormTypeFormConstants.VALIDATION_RULES.CODE_MAX_LENGTH}
            ></Input>
          )}
        </Form.Item>

        <Form.Item label={translate("formType_form.new_form_code")}>
          {getFieldDecorator(FormTypeFormConstants.Fields.CODE, {
            rules: [
              {
                required: true,
                message: translate("formType_form.required_messages", {
                  field: translate("formType_form.code")
                })
              }
            ]
          })(
            <Input
              maxLength={FormTypeFormConstants.VALIDATION_RULES.NAME_MAX_LENGTH}
            />
          )}
        </Form.Item>

        <Form.Item label={translate("formType_form.name")}>
          {getFieldDecorator(FormTypeFormConstants.Fields.NAME, {
            rules: [
              {
                required: true,
                message: translate("formType_form.required_messages", {
                  field: translate("formType_form.name")
                })
              }
            ]
          })(
            <Input
              maxLength={FormTypeFormConstants.VALIDATION_RULES.NAME_MAX_LENGTH}
            />
          )}
        </Form.Item>
      </Form>
    );
  }
}
export default CopyFormTypeForm;
